import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

const PATTERN_VALIDATOR: any = {
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`+=-])[A-Za-z\d\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`+=-]{8,256}$/,
  newPassword:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`+=-])[A-Za-z\d\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`+=-]{8,256}$/,
  postalCode: /^\d{5}$/, // MEMO: al momento la validazione è gestita solo per IT, FR, DE
  phone: /^\+[1-9][0-9]{0,24}$/,
};

export default class Validation {
  static match(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const checkControl = controls.get(checkControlName);

      if (checkControl?.errors && !checkControl.errors['matching']) {
        return null;
      }

      if (control?.value !== checkControl?.value) {
        controls.get(checkControlName)?.setErrors({ matching: true });
        return { matching: true };
      }
      return null;
    };
  }
  static field(controlName: string): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control?.value) {
        return null;
      }
      const pattern = PATTERN_VALIDATOR[controlName];
      if (pattern) {
        if (!pattern.test(control?.value)) {
          return { [`${controlName}`]: true };
        }
        return null;
      }
      return null;
    };
  }
  static noWhitespaceValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    if (control.value && control.value.trim() !== control.value) {
      return { whitespace: true };
    }
    return null;
  }
}

export function getFormErrors(controls: {
  [key: string]: AbstractControl<any, any>;
}): ValidationErrors | null {
  const errors: ValidationErrors | null = Object.keys(controls)
    .filter((k) => controls[k].errors != null)
    .reduce((acc, curr) => {
      return {
        ...acc,
        [curr]: controls[curr].errors,
      };
    }, {});
  return errors;
}

export function validateForm(
  formGroup: FormGroup,
  callback: (error: { requiredError: boolean; invalidError: boolean }) => void
): boolean {
  if (!formGroup.valid) {
    formGroup.markAllAsTouched();
    const controls = formGroup.controls;
    if (controls) {
      const errors = getFormErrors(controls);
      if (errors) {
        let requiredError = Object.values(errors).some((e) =>
          e.hasOwnProperty('required')
        );
        let invalidError = Object.values(errors).some((e) =>
          e.hasOwnProperty('invalid')
        );
        callback({ requiredError, invalidError });
      }
    }
    return false;
  }
  return true;
}
